import { render, staticRenderFns } from "./MenuGeneratorSegment.vue?vue&type=template&id=563b59e3"
import script from "./MenuGeneratorSegment.vue?vue&type=script&lang=js"
export * from "./MenuGeneratorSegment.vue?vue&type=script&lang=js"
import style0 from "./MenuGeneratorSegment.vue?vue&type=style&index=0&id=563b59e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports